/* Publish by EComposer at 2026-09-28 08:50:32*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7vapvvg876p"]=  window.__ectimmers["ecom-7vapvvg876p"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-7vapvvg876p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7vapvvg876p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-675znutwlbq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-675znutwlbq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ga0onm08n7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ga0onm08n7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vqw2tz50yl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vqw2tz50yl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3c74mz0w9yg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3c74mz0w9yg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xvtwq9uez1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xvtwq9uez1', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}